import { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Plus, Trash2, Pencil, ChevronRight, ChevronDown, BookOpen, Layers, FolderOpen, Tag, Check, X } from 'lucide-react';

var TYPE_META = {
  subject:  { label: 'Matière',  icon: BookOpen,   cls: 'text-blue-400 bg-blue-400/10 border-blue-400/20', childType: 'theme',   childLabel: 'thème' },
  theme:    { label: 'Thème',    icon: Layers,      cls: 'text-violet-400 bg-violet-400/10 border-violet-400/20', childType: 'chapter', childLabel: 'section' },
  chapter:  { label: 'Section',  icon: FolderOpen,  cls: 'text-amber-400 bg-amber-400/10 border-amber-400/20', childType: 'notion',  childLabel: 'notion' },
  notion:   { label: 'Notion',   icon: Tag,         cls: 'text-emerald-400 bg-emerald-400/10 border-emerald-400/20', childType: null,      childLabel: null },
};

export { TYPE_META };

function flattenTree(nodes, depth) {
  var result = [];
  var d = depth || 0;
  for (var i = 0; i < nodes.length; i++) {
    var n = nodes[i];
    result.push({ node: n, depth: d });
    if (n.children && n.children.length > 0) {
      result = result.concat(flattenTree(n.children, d + 1));
    }
  }
  return result;
}

export { flattenTree };

export function TagRow({ node, depth, meta, isOpen, onToggle, onAdd, onRename, onDelete }) {
  var Icon = meta.icon;
  var [editing, setEditing] = useState(false);
  var [editVal, setEditVal] = useState(node.label);

  var submitRename = function() {
    var v = editVal.trim();
    if (v && v !== node.label) onRename(node.tag_id, v);
    setEditing(false);
  };

  var padLeft = depth * 28;

  return (
    <div className="flex items-center gap-2 py-1.5 px-2 rounded-lg hover:bg-muted/30 transition-colors group" style={{ paddingLeft: padLeft + 8 }} data-testid={"tag-node-" + node.tag_id}>
      {meta.childType ? (
        <button onClick={function() { onToggle(node.tag_id); }} className="w-5 h-5 flex items-center justify-center text-muted-foreground shrink-0" data-testid={"toggle-" + node.tag_id}>
          {isOpen ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
        </button>
      ) : <span className="w-5" />}

      <span className={"inline-flex items-center gap-1.5 text-xs font-medium px-2 py-0.5 rounded-full border " + meta.cls}>
        <Icon className="w-3 h-3" />{meta.label}
      </span>

      {editing ? (
        <span className="flex items-center gap-1 flex-1">
          <Input value={editVal} onChange={function(e) { setEditVal(e.target.value); }} className="h-7 text-sm flex-1" autoFocus
            onKeyDown={function(e) { if (e.key === 'Enter') submitRename(); if (e.key === 'Escape') setEditing(false); }}
            data-testid={"edit-input-" + node.tag_id} />
          <Button type="button" variant="ghost" size="sm" className="h-7 w-7 p-0 text-emerald-400" onClick={submitRename}><Check className="w-3.5 h-3.5" /></Button>
          <Button type="button" variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={function() { setEditing(false); setEditVal(node.label); }}><X className="w-3.5 h-3.5" /></Button>
        </span>
      ) : (
        <span className="text-sm font-medium flex-1">{node.label}</span>
      )}

      {!editing && (
        <span className="flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
          {meta.childType && (
            <Button variant="ghost" size="sm" className="h-7 px-2 text-xs text-muted-foreground hover:text-primary" onClick={function() { onAdd(node.tag_id, meta.childType); }} data-testid={"add-child-" + node.tag_id}>
              <Plus className="w-3 h-3 mr-1" />{meta.childLabel}
            </Button>
          )}
          <Button variant="ghost" size="sm" className="h-7 w-7 p-0 text-muted-foreground hover:text-foreground" onClick={function() { setEditing(true); }} data-testid={"rename-" + node.tag_id}>
            <Pencil className="w-3 h-3" />
          </Button>
          <Button variant="ghost" size="sm" className="h-7 w-7 p-0 text-muted-foreground hover:text-destructive" onClick={function() { onDelete(node); }} data-testid={"delete-" + node.tag_id}>
            <Trash2 className="w-3 h-3" />
          </Button>
        </span>
      )}
    </div>
  );
}
